import { render } from "./popup_price.vue?vue&type=template&id=45d450be"
import script from "./popup_price.vue?vue&type=script&lang=js"
export * from "./popup_price.vue?vue&type=script&lang=js"

import "./popup_price.vue?vue&type=style&index=0&id=45d450be&lang=scss"

import exportComponent from "K:\\konisheva\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon,QImg,QSeparator,QSpinner});
